<template>
  <div>
    <b-modal
      id="modal-edit-mitra"
      size="lg"
      centered
      title="Edit Data Master Mitra Pusat"
      header-bg-variant="warning"
      header-text-variant="light"
      @show="showModal()"
    >
      <b-form>
        <b-form-group label="Nama APP" label-cols-md="3">
          <b-form-input
            autofocus
            type="text"
            :state="checkIfValid('namaApp')"
            v-model="$v.data.namaApp.$model"
          ></b-form-input>
        </b-form-group>
        <b-form-group label="Logo APP" label-cols-md="3">
          <b-form-file
            class="inputan"
            ref="file1"
            type="file"
            @input="handleFile()"
          ></b-form-file>
          <div class="my-3 w-50">
            <b-img :src="viewImage" fluid alt="logo" rounded></b-img>
            <!-- <b-img v-if="image" :src="image" fluid alt="logo" rounded></b-img>
            <b-img v-else :src="$be + data.logoApp" fluid alt="logo" rounded></b-img> -->
            <!-- <b-img :src="image ? image : $be + data.logoApp" fluid alt="logo" rounded></b-img> -->
            <!-- <b-img :src="$be + (!$be.includes('localhost') && $tore.state.kode_client ? 'api-' + $tore.state.kode_client + '/' : '') + $store.state.mitra_aktif.logoApp" fluid alt="logo"></b-img> -->
          </div>
        </b-form-group>
        <b-form-group label="Nama Mitra" label-cols-md="3">
          <b-form-input
            type="text"
            :state="checkIfValid('namaMitra')"
            v-model="$v.data.namaMitra.$model"
          ></b-form-input>
        </b-form-group>
        <b-form-group label="Tanggal Gajian" label-cols-md="3">
          <b-form-input
              type="number"
              :state="checkIfValid('tanggalGaji')"
              v-model="$v.data.tanggalGaji.$model"
            ></b-form-input>
        </b-form-group>
        <b-form-group label="Tanggal Tutup Buku" label-cols-md="3">
          <b-form-input
              type="number"
              :state="checkIfValid('tanggalClosing')"
              v-model="$v.data.tanggalClosing.$model"
            ></b-form-input>
        </b-form-group>
        <b-form-group label="BPJS Ketenagakerjaan" label-cols-md="3">
          <b-form-input
            type="number"
            :state="checkIfValid('bebanTenagaKerjaPerusahaan')"
            v-model="$v.data.bebanTenagaKerjaPerusahaan.$model"
          ></b-form-input>
        </b-form-group>
        <b-form-group label="BPJS Kesehatan" label-cols-md="3">
          <b-form-input
            type="number"
            :state="checkIfValid('bebanKesehatanPerusahaan')"
            v-model="$v.data.bebanKesehatanPerusahaan.$model"
          ></b-form-input>
        </b-form-group>
      </b-form>
      <!-- <img :src="src1" /> -->
      <template #modal-footer>
        <b-button
          variant="secondary"
          @click="$bvModal.hide('modal-edit-mitra')"
        >
          Tutup
        </b-button>
        <b-button
          variant="primary"
          :disabled="busy || !isValid"
          @click="simpan()"
        >
          {{ button }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import _ from "lodash";
import { validationMixin } from "vuelidate";
import { required, maxValue } from "vuelidate/lib/validators";
export default {
  props: ["data"],
  data() {
    return {
      file1: null,
      image: null,
      busy: false,
      button: "Simpan",
    };
  },
  computed: {
    formString() {
      return JSON.stringify(this.data, null, 4);
    },
    isValid() {
      return !this.$v.data.$invalid;
    },
    isDirty() {
      return this.$v.data.$anyDirty;
    },
    renderImage(){
      return this.data.image
    },
    viewImage(){
      const vm = this
      if(vm.image){
        return vm.image
      }else if(vm.data.logoApp){
        if(vm.$be.includes('localhost')){
          return vm.$be + vm.data.logoApp
        }else if(vm.$store.state.kode_client){
          return vm.$be + 'api-' + vm.$store.state.kode_client + '/' + vm.data.logoApp
        }
      }
      return ''
    }
  },
  mixins: [validationMixin],
  validations: {
    data: {
      namaApp: {
        required,
      },
      namaMitra: {
        required,
      },
      tanggalGaji: {
        required,
        maxValue: maxValue(31),
      },
      tanggalClosing: {
        required,
        maxValue: maxValue(31),
      },
      bebanTenagaKerjaPerusahaan: {
        required,
      },
      bebanKesehatanPerusahaan: {
        required,
      },
    },
  },
  methods: {
    checkIfValid(fieldName) {
      const field = this.$v.data[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    showModal(){
      this.image = null
    },
    handleFile() {
      const file = this.$refs.file1.files[0]
      this.file1 = file;
      const reader = new FileReader()
      reader.onload = (event) => {
        this.image = event.target.result
      }
      reader.readAsDataURL(file)
    },
    simpan() {
      let vm = this;
      if (vm.isValid) {
        vm.busy = true;
        vm.button = "Mohon Tunggu";
        const formData = new FormData();
        formData.append("id", vm.data.mitraId);
        if(vm.file1) formData.append("file1", vm.file1);
        formData.append("namaApp", vm.data.namaApp);
        formData.append("namaMitra", vm.data.namaMitra);
        formData.append("tanggalGaji", vm.data.tanggalGaji);
        formData.append("tanggalClosing", vm.data.tanggalClosing);
        formData.append("bebanTenagaKerjaPerusahaan", vm.data.bebanTenagaKerjaPerusahaan);
        formData.append("bebanKesehatanPerusahaan", vm.data.bebanKesehatanPerusahaan);
        vm.$axios
          .post("mitra/update", formData)
          .then((res) => {
            if (res.data.message == "sukses") {
              vm.button = "Simpan";
              vm.busy = false;
              vm.$emit("alertFromChild", {
                variant: "success",
                msg: "BERHASIL MENGUBAH DATA MITRA",
                showing: true,
              });
              this.$bvModal.hide("modal-edit-mitra");
            } else {
              vm.button = "Simpan";
              vm.busy = false;
              vm.$emit("alertFromChild", {
                variant: "danger",
                msg: _.toUpper(res.data.message),
                showing: true,
              });
            }
          })
          .catch(() => {
            vm.button = "Simpan";
            vm.busy = false;
            vm.$emit("alertFromChild", {
              variant: "danger",
              msg: "TERJADI KESALAHAN PADA SERVER",
              showing: true,
            });
          });
      }
    },
  },
};
</script>
